(() => {
  const shippingPattern = /free\s*&\s*fast\s*australia\s*wide\s*shipping/i;
  const afterpaySelectors = [
    '[id*="afterpay_on_site_messaging"]',
    '[id*="afterpay"][class*="shopify"]',
    'afterpay-placement',
    '[data-afterpay-placement]',
    '.afterpay-paragraph',
  ];

  function findAfterpayBlock() {
    for (const selector of afterpaySelectors) {
      const element = document.querySelector(selector);
      if (element) return element.closest('.shopify-block') || element;
    }
  }

  function findShippingMessage() {
    const candidates = [...document.querySelectorAll('p, span, div')].filter((element) => {
      const text = element.textContent?.replace(/\s+/g, ' ').trim() || '';
      return shippingPattern.test(text) && text.length < 100;
    });

    return candidates.sort((first, second) => first.children.length - second.children.length)[0];
  }

  function positionShippingMessage() {
    if (!document.querySelector('main[data-template^="product"]')) return true;

    const afterpayBlock = findAfterpayBlock();
    const shippingMessage = findShippingMessage();
    if (!afterpayBlock || !shippingMessage || afterpayBlock.contains(shippingMessage)) return false;

    const originalContainer = shippingMessage.parentElement;
    const giftOnlyElements = originalContainer
      ? [...originalContainer.querySelectorAll('span, p, div')].filter(
          (element) => element !== shippingMessage && element.textContent?.trim() === '🎁'
        )
      : [];

    giftOnlyElements.forEach((element) => element.remove());

    for (const node of shippingMessage.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent?.includes('🎁')) {
        node.textContent = node.textContent.replaceAll('🎁', '').trimStart();
      }
    }

    shippingMessage.classList.add('aa-shipping-under-afterpay');
    afterpayBlock.insertAdjacentElement('afterend', shippingMessage);
    return true;
  }

  if (!positionShippingMessage()) {
    const observer = new MutationObserver(() => {
      if (positionShippingMessage()) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 8000);
  }
})();
